<template>
    <div class="text-center">
        <img src="../../../public/img/brand/default.png" alt="" width="40px">
        <h3 class="mt-3 ">DCC PORTAL</h3>
        <p class="text-sm">
            <b>Copyright </b> &copy; {{ year }}&nbsp;Digital Communications Consulting LLC. All Rights Reserved.
        </p>
        <p class="text-xs">
            Developed by: <a href="#" title="FuzeMobi" target="_blank">FuzeMobi, LLC.</a> <br>
            Designed by: <a href="#">Chad Rosenbohm</a><br>
            UX Version: {{ uxVersion }} <br>
            API Version: {{ apiVersion }} <br>
          </p>
    </div>
</template>

<script>
import initService from "../../common/api-services/init-service";
export default {
    name: 'About-App',
    components: {

    }, 
    data() {
        return {
            year: new Date().getFullYear(),
          apiVersion: '',
          uxVersion: '',
        }
    },
    mounted() {
      this.getVersions();
    },
    methods: {
      getVersions() {
        this.uxVersion=initService.getUxVersion();
        initService.getApiVersion().then((res) => {
          this.apiVersion=res.toString();
        });
      },
    }
}
</script>